import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useCallback, useContext, useState } from 'react'
import { TenantsContext } from '../../../../context/tenants.context'
import { duplicarProducto } from '../../services/productos.service'
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone'
import SnackBarUtils from '../../../../utils/SnackBarUtils'
import { ProductosAdminContext } from '../../context/productos.context'

interface Props {
  open: boolean
  setOpen: (op: boolean) => void
  codProducto: string
}
/* eslint-disable react/prop-types */
const DuplicarProducto: React.FC<Props> = ({ open, setOpen, codProducto }) => {
  const [aprobado, setAprobado] = useState<boolean>(true)
  const [loading, setLoading] = useState<boolean>(false)
  const [newCode, setNewCode] = useState<string>(null)
  const [copiado, setCopiado] = useState<boolean>(false)
  const { tenant } = useContext(TenantsContext)
  const { fetchData } = useContext(ProductosAdminContext)

  const duplicar = useCallback(async () => {
    try {
      setLoading(true)
      const res = await duplicarProducto(tenant, codProducto, aprobado)
      setNewCode(res.data.data)
      SnackBarUtils.success('Producto duplicado')
      fetchData()
    } catch (e) {
      console.log(e)
      SnackBarUtils.error(e.message === 'Network Error' ? 'Ocurrió un error al duplicar el producto' : e.message)
    } finally {
      setLoading(false)
    }
  }, [tenant, codProducto, aprobado])

  const handleClose = () => {
    setOpen(false)
    setAprobado(true)
    setNewCode(null)
    setCopiado(false)
  }

  if (!codProducto) return

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: { overflowX: 'hidden', ...(newCode && { paddingTop: '1rem' }), ...(!open && { display: 'none' }) }
      }}
    >
      {!newCode && <DialogTitle sx={{ mt: 2 }}>Elegí el estado del nuevo producto</DialogTitle>}
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        {newCode ? (
          <>
            <Typography>
              Se duplicó el producto. El nuevo código es <strong>{newCode}</strong>{' '}
              <ContentCopyTwoToneIcon
                sx={{ cursor: 'pointer' }}
                onClick={() => {
                  setCopiado(true)
                  navigator.clipboard.writeText(newCode)
                  SnackBarUtils.success('Código copiado al portapapeles')
                }}
                color={copiado ? 'primary' : 'action'}
                titleAccess="Copiar código"
              />
            </Typography>
          </>
        ) : (
          <>
            <Box sx={{ display: 'flex', flexDirection: 'row', flex: 1, gap: '1rem' }}>
              <Button
                disabled={loading}
                variant={aprobado ? 'contained' : 'outlined'}
                color="success"
                onClick={() => setAprobado(true)}
                fullWidth
              >
                Aprobado
              </Button>
              <Button
                disabled={loading}
                variant={aprobado ? 'outlined' : 'contained'}
                color="success"
                onClick={() => setAprobado(false)}
                fullWidth
              >
                Pausado
              </Button>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', flex: 1, gap: '1rem' }}>
              <Button disabled={loading} variant="contained" type="submit" onClick={duplicar} fullWidth>
                Duplicar
              </Button>
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <IconButton
          edge="end"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: '0',
            right: '0',
            paddingRight: '16px'
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogActions>
    </Dialog>
  )
}

export default DuplicarProducto
